import gql from 'graphql-tag'
import client from '@stores/apollo'
import { ExportStatusFragment } from '@api/fragments'

const query = gql`
  query EmployeeExportStatus($exportId: String!) {
    viewer {
      company {
        employees {
          exportStatus(exportId: $exportId) {
            ...ExportStatusFragment
          }
        }
      }
    }
  }
  ${ExportStatusFragment}
`

export interface ExportStatus {
  progress: number
  total: number
  url?: string
}

interface Payload {
  data: {
    viewer: {
      company: {
        employees: {
          exportStatus: ExportStatus
        }
      }
    }
  }
}

export default function checkExportStatus(variables: { exportId: string }): Promise<ExportStatus> {
  return client.gql.query({ query, variables }).then(
    ({
      data: {
        viewer: {
          company: {
            employees: { exportStatus },
          },
        },
      },
    }: Payload) => exportStatus
  )
}
